













import {
  computed,
  defineComponent,
  PropType,
  toRefs
} from '~/utils/nuxt3-migration'
import { OrderStatus } from '~/models/marketplace/order'
import {
  orderPendingStatuses,
  orderFailStatuses,
  orderSuccessStatuses
} from '~/constants/marketplace'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'
import { useI18n } from '~/compositions/i18n'
import { ciTimes } from '~/icons/source/regular/times'
import { ciCheckSimple } from '~/icons/source/solid/ciCheckSimple'

export default defineComponent({
  components: { CBadge },
  props: {
    status: {
      type: String as PropType<OrderStatus>,
      required: true
    }
  },
  setup(props) {
    const { status } = toRefs(props)
    const { t } = useI18n()

    const statusIcon = computed(() => {
      switch (status.value) {
        case OrderStatus.CANCELLED_BY_SELLER:
        case OrderStatus.CANCELLED_BY_USER:
        case OrderStatus.DECLINED:
          return ciTimes
        case OrderStatus.COMPLETED:
        case OrderStatus.RETURN_ACCEPTED:
          return ciCheckSimple
        default:
          return null
      }
    })

    const badgeVariant = computed(() => {
      if (orderSuccessStatuses.includes(status.value)) {
        return 'success'
      } else if (orderFailStatuses.includes(status.value)) {
        return 'danger'
      } else if (orderPendingStatuses.includes(status.value)) {
        return 'info'
      }
      return 'info'
    })

    return {
      statusIcon,
      badgeVariant,
      t
    }
  }
})
